/**
 * Set/Remove attribute tuple hook.
 *
 * @param ref Ref to the DOM element.
 */
export const useSetAttribute = ref => [
  (name, value) => {
    var _a, _b;
    return ((_a = ref.current) === null || _a === void 0
      ? void 0
      : _a.getAttribute(name)) !== value
      ? (_b = ref.current) === null || _b === void 0
        ? void 0
        : _b.setAttribute(name, value)
      : undefined;
  },
  name => {
    var _a, _b;
    return (
      (_a = ref.current) === null || _a === void 0
        ? void 0
        : _a.getAttribute(name)
    )
      ? (_b = ref.current) === null || _b === void 0
        ? void 0
        : _b.removeAttribute(name)
      : undefined;
  }
];
export default useSetAttribute;
